import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import { capitalize } from '@attain-apps/string-utils'

import * as state from '../../../../../../../state'

@ngCore.Component({
  imports: [ds.input.text.Component, ds.input.iconpicker.Component],
  selector: 'atn-app-general-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.apps.Collection} */
  private readonly _appsEc = ngCore.inject(state.admin.apps.Collection)

  /** Editing app */
  private readonly _appSg = ngCore.computed(() =>
    this._appsEc.plugins.currentEntityPlugin.feature.selectors
      .getEditedEntity()
      .asSignal(),
  )

  /** Editing app name*/
  public readonly appNameSg = ngCore.computed(
    (app = this._appSg()) => app?.name,
  )

  /** Editing app alias*/
  public readonly appAliasSg = ngCore.computed(
    (app = this._appSg()) => app?.alias,
  )

  /** Editing app description*/
  public readonly appDescriptionSg = ngCore.computed(
    (app = this._appSg()) => app?.description,
  )

  /** Editing app icon */
  public readonly appIconSg = ngCore.computed(
    (app = this._appSg()) => app?.icon,
  )

  /** Currently editing app id for given editing target */
  private readonly _appIdSg = ngCore.computed(
    (
      app = this._appsEc.plugins.currentEntityPlugin.feature.selectors
        .getEditedEntityAndId()
        .asSignal(),
    ) => app.id,
  )
  /**
   * Updates a specific property of the currently edited app entity.
   */
  public updateAppPropertyHandler<K extends keyof ents.core.admin.App.Input>(
    prop: K,
    value: ents.core.admin.App.Input[K],
  ): void {
    this._appsEc.plugins.editingPlugin.feature.actions.edit
      .from(`Dialog.${capitalize(prop)}.Inputted`)
      .dispatch({
        edit: app => {
          if (!app) {
            return
          }
          app[prop] = value
        },
        id: this._appIdSg(),
      })
  }
}
